<script setup>
defineProps(['model'])
</script>

<template>
  <!-- Editorial Block -->
  <section class="editorial-block block-spacing w-full">
    <div class=" container-fluid">
      <div
        class="prose"
        :class="{
          'bg-med-light-aqua rounded-xl px-6 py-6 md:p-8': model?.bgColor?.value === 'aqua',
          'rounded-xl px-6 py-6 md:p-8 shadow-[0px_4px_20px_0px_rgba(0,0,0,0.15)]': model?.bgShadow?.value,
        }"
      >
        <div
          v-if="model?.body?.value"
          v-html="convertH1ToH2(stripEmptyHeadings(model?.body?.value))"
        />
        <slot />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.page-block-area {
  .editorial-block {
    @media (min-width: 1600px) {
      max-width: var(--block-width-wide);
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
